import React from 'react';
import { Button, Checkbox } from 'antd';
import type { TCredentialingProvider } from 'types/credentialing';
import s from './s.module.less';

interface Props {
    providers: TCredentialingProvider[];
    selectedProviderIds: string[];
    onSelectedProviderIdsChange: (ids: string[]) => void;
    onContinue: () => void;
}

const ProviderSelectStep = ({
    providers,
    selectedProviderIds,
    onSelectedProviderIdsChange,
    onContinue,
}: Props) => {
    const eligibleProviders = providers.filter((p) => p.onboardingStatus === 'COMPLETED');
    const allSelected = eligibleProviders.length > 0 && eligibleProviders.every((p) => selectedProviderIds.includes(String(p.providerId)));

    const toggleProvider = (id: string) => {
        if (selectedProviderIds.includes(id)) {
            onSelectedProviderIdsChange(selectedProviderIds.filter((pid) => pid !== id));
        } else {
            onSelectedProviderIdsChange([...selectedProviderIds, id]);
        }
    };

    const toggleAll = () => {
        if (allSelected) {
            onSelectedProviderIdsChange([]);
        } else {
            onSelectedProviderIdsChange(eligibleProviders.map((p) => String(p.providerId)));
        }
    };

    return (
        <>
            <div className={s.modalBody}>
                <div className={s.headerRow}>
                    <span className={s.headerLabel}>Which providers are you adding payers for?</span>
                    <span className={s.toggleAllBtn} onClick={toggleAll}>
                        {allSelected ? 'Clear all' : 'Select all'}
                    </span>
                </div>
                <div className={s.providerList}>
                    {providers.map((p) => {
                        const pid = String(p.providerId);
                        const isCompleted = p.onboardingStatus === 'COMPLETED';
                        return (
                            <label key={pid} className={`${s.providerRow}${isCompleted ? '' : ` ${s.disabled}`}`}>
                                <Checkbox
                                    checked={selectedProviderIds.includes(pid)}
                                    onChange={() => toggleProvider(pid)}
                                    disabled={!isCompleted}
                                />
                                <span className={s.providerInfo}>
                                    <span className={s.providerName}>{p.firstName} {p.lastName}</span>
                                    {!isCompleted && (
                                        <span className={s.incompleteTag}>Onboarding incomplete</span>
                                    )}
                                </span>
                            </label>
                        );
                    })}
                </div>
            </div>
            <div className={s.modalFooter}>
                <Button
                    type="primary"
                    block
                    size="large"
                    className={s.primaryBtn}
                    disabled={selectedProviderIds.length === 0}
                    onClick={onContinue}
                >
                    Continue
                </Button>
            </div>
        </>
    );
};

export default ProviderSelectStep;
